module.exports = __webpack_public_path__ + "img/bank-14-jb.94c20199.svg";